import api from './api'

export const organizationsAPI = {
  // Get organization statistics for dashboard
  getStats: () => api.get('/organizations/stats/overview'),
  
  // Get all organizations
  getAll: (params = {}) => api.get('/organizations', { params }),
  
  // Get organization by ID
  getById: (id) => api.get(`/organizations/${id}`),
  
  // Create new organization
  create: (orgData) => {
    // Include window.location.origin (like copy invitation link)
    const dataWithOrigin = {
      ...orgData,
      frontend_url: window.location.origin || 'http://localhost:3000'
    }
    return api.post('/organizations', dataWithOrigin)
  },
  
  // Update organization
  update: (id, orgData) => api.put(`/organizations/${id}`, orgData),
  
  // Delete organization
  delete: (id) => api.delete(`/organizations/${id}`),
  
  // Update organization status
  updateStatus: (id, status) => api.patch(`/organizations/${id}/status`, { status }),
  
  // Update organization branding
  updateBranding: (id, data) => {
    if (data instanceof FormData) {
      return api.patch(`/organizations/${id}/branding`, data, {
        headers: { 'Content-Type': undefined }
      })
    }
    return api.patch(`/organizations/${id}/branding`, data)
  },
  
  // Search organizations
  search: (params) => api.get('/organizations/search', { params }),
  
  // Get organization users
  getUsers: (id) => api.get(`/organizations/${id}/users`),
  
  // Get organization products
  getProducts: (id) => api.get(`/organizations/${id}/products`)
}



